export default __webpack_public_path__ + "static/media/coreCard3.11d9e3ba.svg";